module.exports = __webpack_public_path__ + "img/ayos-logo.9b6d3388.png";